import { render, staticRenderFns } from "./Valija.vue?vue&type=template&id=68e66056&lang=pug"
import script from "./Valija.vue?vue&type=script&lang=js"
export * from "./Valija.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports